import type { ComponentPropsWithoutRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props extends ComponentPropsWithoutRef<typeof Box> {}

function SettingsGroup(props: Props) {
  return (
    <Box
      {...props}
      gap="s12"
      paddingY="s16"
      paddingX="s24"
      border={{
        all: {
          color: 'grey400',
          width: 's2',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      {props.children}
    </Box>
  )
}

export default SettingsGroup
